import { EditProductForm } from 'modules/Products/drawers/EditProduct/EditProductForm'
import { useEditProductOutletConnector } from 'modules/Products/drawers/EditProduct/useEditProductOutletConnector'

export const EditProductRouteComponent = () => {
  const { onCancel, onSuccess } = useEditProductOutletConnector()

  return <EditProductForm onClose={onCancel} onEdit={onSuccess} />
}
